<template>
    <div class="auth-wrapper middle-aligner">
        <div class="inner">
            <div class="card card-auth with-shadow">
                <h2 class="auth-heading">
                    Forgot your password?
                    <span>
                        Please provide your username and we'll send you
                        instructions on how to change your password.
                    </span>
                </h2>
                <div class="auth-body">
                    <b-form @submit.stop.prevent="onSubmit()">
                        <b-form-group
                            id="forgot-pass-input"
                            label="username"
                            label-for="forgot-pass"
                        >
                            <b-form-input
                                id="forgot-pass-field"
                                v-model="username"
                                v-validate="{ required: true, max: 200 }"
                                type="text"
                                placeholder="Enter your account username"
                                data-vv-name="username"
                                :class="{
                                    'is-invalid': errors.has('username'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                        <base-button
                            btn-label="SEND INSTRUCTIONS"
                            btn-type="submit"
                            btn-variant="primary"
                            :class="loading ? 'disabled' : ''"
                        ></base-button>

                        <router-link
                            :to="{ name: 'login-page' }"
                            class="btn forgot-link btn-link float-right"
                            >Back to login</router-link
                        >
                        <base-toast></base-toast>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {},
    /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
    props: {}, // End of Component > props

    /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
    data() {
        return {
            username: '',
        }
    }, // End of Component > data

    /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
    computed: {
        ...mapGetters(['loading', 'data']),
    }, // End of Component > methods

    /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
    mounted() {}, // End of Component > computed

    /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
    methods: {
        async onSubmit() {
            const result = await this.$validator.validateAll()

            if (result) {
                try {
                    let response = await this.$store.dispatch(
                        'authForgotPassword',
                        {
                            username: this.username,
                        }
                    )
                    if (response) {
                        this.$emit('show-email')
                    }
                } catch (error) {
                    //console.log(error)
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() methods
    }, // End of Component > mounted
} // End of export default
</script>
